import { DIRECT_TO_APPLICATION_OFFER_IDS } from './constants';

export const isDirectToApplicationOffer = (offer: { id: string }) => {
  return DIRECT_TO_APPLICATION_OFFER_IDS.includes(offer.id);
};

export const addDirectToApplicationParam = (url: string): string => {
  const parsedUrl = new URL(url);
  parsedUrl.searchParams.set('alt', 'dta');
  return parsedUrl.toString();
};
